import e from "parse-unit";

var r = function r(_r) {
  return e(_r)[0];
};

export default function (n) {
  return null == n && (n = n), function (t, i, u, f) {
    null == u && (u = n), null == f && (f = u);

    var l = function (r) {
      return e(r)[1];
    }(t);

    if (l === i) return t;
    var o = r(t);
    if ("px" !== l) if ("em" === l) o = r(t) * r(u);else if ("rem" === l) o = r(t) * r(n);else {
      if ("ex" !== l) return t;
      o = r(t) * r(u) * 2;
    }
    var a = o;
    if ("px" !== i) if ("em" === i) a = o / r(f);else if ("rem" === i) a = o / r(n);else {
      if ("ex" !== i) return t;
      a = o / r(f) / 2;
    }
    return parseFloat(a.toFixed(5)) + i;
  };
}